export default __webpack_public_path__ + "static/media/vbb-full-logo.225455aa.png";